/* eslint-disable guard-for-in */
import wtSdk from '@ali/dingtalk-watt-trace-sdk';
var TRACE_ID = 'ddm-trace-id';
var TRACE_PARAMS = 'ddm-trace-params';
// const record = (window as any).goldlog && (window as any).goldlog.record;
var ua = window.navigator.userAgent.toLowerCase();
var isInDD = ua.indexOf('dingtalk') > -1;
// 初始化
function initTrace() {
    window.WTSDK = wtSdk;
    document.addEventListener('click', function (e) {
        var el = findTraceElement(e.target);
        if (el) {
            sendLog(el, { isExpose: false });
        }
    }, true);
    setTimeout(function () {
        // 曝光
        var wtid = window.WTSDK.default.getwtid();
        if (isInDD) {
            window.WTSDK.default.trace.log({ type: 'pageload', position: wtid });
        }
        // 黄金令箭打点
        var record = window.goldlog && window.goldlog.record;
        if (record) {
            record('/dd_home.ddm.trace', 'CLK', "action=pageload__" + wtid, 'GET');
        }
    }, 200);
    // 检测dom变化的实现：
    // 1.预览页面不执行曝光方法，onload事件有冲突
    // 2.onload 找到监听符合标准（有ddm-trace-id）的dom，dom都绑定一次 IntersectionObserver的监听 ，同时配置MutationObserver监听dom树的变化
    // 3.MutationObserver监听到变化后，判断是dom树（childList类型）变化还是属性变化（attributes类型）
    // 4.如果是dom树变化，执行绑定曝光监听方法
    // 5.如果是属性变化，变化的dom（需要符合标准，有ddm-trace-id的dom） 和 现有的监听dom列表（__obsDomList）进行对比，看是否能找到一样的，
    // 如果找不到，认为是dom有变化，执行绑定曝光监听方法
    // 
    // 绑定曝光监听的实现：
    // 1.先解除所有dom的监听
    // 2.延迟100ms等待dom渲染完毕，找到符合标准的dom，
    // 3.和已经曝光dom的id集合（__hasExposeDomIDList）进行对比，没有自信过曝光打点的dom绑定曝光监听
    // 备注：100ms的timer做了唯一性处理，避免快速点击带来的重复执行问题
    // 
    // 曝光行为的实现：
    // 1.检测是否可见
    // 2.执行上报函数（sendLog）
    // 3.把上报dom的ddm-trace-id的值存下来，添加到曝光dom的id集合中
    // 4.接触dom的IntersectionObserver 监听
    if (!window.IntersectionObserver || !window.MutationObserver) {
        return;
    }
    if (window.location.href.indexOf('wh_preview=maintain') > -1 && window.location.href.indexOf('/preview/') > -1) {
        return;
    }
    // 监听的domlist
    window.__obsDomList = [];
    // 已经曝光的dom id集合
    window.__hasExposeDomIDList = [];
    // 可视区域的监听
    window.__IntersectionObs = new window.IntersectionObserver(function (changes) {
        for (var _i = 0, changes_1 = changes; _i < changes_1.length; _i++) {
            var change = changes_1[_i];
            // console.log('id::', getTraceId(change.target), change.isIntersecting, change.intersectionRatio)
            if (change.isIntersecting || change.intersectionRatio >= 1) {
                // 上报打点
                sendLog(change.target, { isExpose: true });
                window.__hasExposeDomIDList.push(getTraceId(change.target));
                // 上报完去除监听
                window.__IntersectionObs && window.__IntersectionObs.unobserve(change.target);
            }
        }
    }, { threshold: 1 });
    var __timer = null;
    // 绑定曝光监听
    var obsDomFunc = function () {
        __timer && clearTimeout(__timer);
        window.__obsDomList.forEach(function (dom) {
            window.__IntersectionObs && window.__IntersectionObs.unobserve(dom);
        });
        __timer = setTimeout(function () {
            window.__obsDomList = document.querySelectorAll("div[ddm-trace-id]");
            window.__obsDomList.forEach(function (dom) {
                var hasExpose = false;
                window.__hasExposeDomIDList.forEach(function (id) {
                    if (getTraceId(dom) === id) {
                        hasExpose = true;
                    }
                });
                if (hasExpose) {
                    return;
                }
                window.__IntersectionObs && window.__IntersectionObs.observe(dom);
            });
        }, 100);
    };
    // onload事件
    window.onload = function () {
        window.__obsDomList = document.querySelectorAll("div[ddm-trace-id]");
        window.__obsDomList.forEach(function (dom) {
            window.__IntersectionObs && window.__IntersectionObs.observe(dom);
        });
        window.__MutationObs = new MutationObserver(function (mutationList) {
            var hasDomChange = false;
            mutationList.forEach(function (mu) {
                if (mu.type === 'childList') {
                    hasDomChange = true;
                }
            });
            // console.log(2222, mutationList, hasDomChange);
            if (hasDomChange) {
                obsDomFunc();
            }
            else {
                var hasAttrChange_1 = true;
                mutationList.forEach(function (mu) {
                    if (mu.target.nodeValue && mu.target.nodeValue.toString().indexOf('ddm-trace-id') > -1) {
                        window.__obsDomList.forEach(function (oldDom) {
                            if (oldDom.nodeValue.toString() === mu.target.nodeValue.toString()) {
                                hasAttrChange_1 = false;
                            }
                        });
                    }
                });
                // console.log('hasAttrChange:::', hasAttrChange);
                if (hasAttrChange_1) {
                    obsDomFunc();
                }
            }
        });
        window.__MutationObs && window.__MutationObs.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
        });
    };
}
// 打点
function sendLog(el, _a) {
    var _b = _a.isExpose, isExpose = _b === void 0 ? false : _b;
    var key = getTraceId(el);
    if (!key) {
        return;
    }
    if (isExpose) {
        key = "expose-" + key;
    }
    var params = getTraceParams(el);
    if (params) {
        try {
            params = JSON.parse(params);
        }
        catch (e) {
            // 
        }
    }
    // watt打点sdk
    if (isInDD) {
        window.WTSDK.default.trace.log({ type: 'click', position: key, extParams: params });
    }
    // 黄金令箭打点
    var record = window.goldlog && window.goldlog.record;
    if (record) {
        var wtid = window.WTSDK.default.getwtid();
        var traceKeys = [];
        traceKeys.push(wtid + "-" + key);
        if (params && Object.keys(params).length > 0) {
            for (var k in params) {
                traceKeys.push(k + "-" + params[k]);
            }
        }
        record('/dd_home.ddm.trace', 'CLK', "action=" + traceKeys.join('__'), 'GET');
    }
}
// 找到有traceid的dom
function findTraceElement(node) {
    if (!node || node === document.body) {
        return null;
    }
    if (typeof node.getAttribute === 'function' && node.getAttribute(TRACE_ID)) {
        return node;
    }
    return findTraceElement(node.parentNode);
}
function getTraceId(target) {
    var traceId = target.getAttribute(TRACE_ID);
    return traceId;
}
function getTraceParams(target) {
    var paramsStr = target.getAttribute(TRACE_PARAMS) || '{}';
    return paramsStr;
}
export default {
    initTrace: initTrace,
};
